import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import VideoShowcase from "@/components/VideoShowcase";
import Services from "@/components/Services";
import Diferenciais from "@/components/Diferenciais";
import Reviews from "@/components/Reviews";
import Banner from "@/components/Banner";
import Areas from "@/components/Areas";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import SchemaJSONLD from "@/components/SchemaJSONLD";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="relative min-h-screen bg-brand-black font-body text-white antialiased"
    >
      <SmoothScroll />
      <SchemaJSONLD />
      {/* grain overlay */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[60] opacity-[0.06] mix-blend-overlay"
        style={{
          backgroundImage:
            'url("data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22160%22 height=%22160%22><filter id=%22n%22><feTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%222%22 stitchTiles=%22stitch%22/></filter><rect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22 opacity=%220.55%22/></svg>")',
        }}
      />

      <Nav />
      <Hero />
      <EditorialMarquee />
      <VideoShowcase />
      <Services />
      <Diferenciais />
      <Reviews />
      <Banner />
      <Areas />
      <FinalCTA />
      <Footer />
      <FloatingActions />

      {/* bottom spacer so mobile sticky bar never covers last content */}
      <div className="h-16 md:hidden" aria-hidden="true" />
    </main>
  );
}
